window.customElements.define(
    "basic-dialog",
    class extends HTMLElement {
        private readonly dialog: HTMLDialogElement | null;
        private readonly toggleButton: HTMLButtonElement | null;

        constructor() {
            super();

            this.toggleButton = this.querySelector("[aria-haspopup='dialog']");
            this.dialog = this.querySelector("dialog");
        }

        connectedCallback() {
            this.toggleButton?.addEventListener(
                "click",
                (event) => {
                    event.preventDefault();
                    this.dialog?.showModal();
                },
            )
        }
    },
);
